import { Select } from '@amzn/stencil-react-components/select';
import { InputWrapper } from '@amzn/stencil-react-components/input';
import { Checkbox } from '@amzn/stencil-react-components/checkbox';
import { Col, Row, Spacer } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { updateCountriesResults } from '../../../actions/initializeDataActions';
import { updateActiveFilters, updateCountries } from '../../../actions/ruleFiltersActions';
import { LIMIT } from '../../../constants/attributes';
import { COUNTRY_INFO, SegmentFilters } from '../../../constants/createSegment';
import {
  activeRuleFiltersSelector,
  initialDataSelector,
  ruleFilterCountriesSelector,
} from '../../../selectors/selectors';
import MultiSelectInput from '../../atoms/MultiSelectInput';

import { IconInformationSmall } from '@amzn/stencil-react-icons';

const IconWithTooltip = withTooltip()(IconInformationSmall);
const CountryFilter = () => {
  const dispatch = useDispatch();
  const activeFilters = useSelector(activeRuleFiltersSelector);
  const countries = useSelector(ruleFilterCountriesSelector);
  const { countriesOptions } = useSelector(initialDataSelector);

  useEffect(() => {
    dispatch(updateCountriesResults());
  }, []);

  const [isDisabled, setIsDisabled] = useState(
    !activeFilters?.includes(SegmentFilters.COUNTRY_FILTER),
  );
  const [selectedCountries, setSelectedCountries] = useState(countries);

  const onFilterChange = e => {
    setIsDisabled(!e?.target?.checked);
    let currentFilter = cloneDeep(activeFilters);
    currentFilter = currentFilter.filter(f => f !== SegmentFilters.COUNTRY_FILTER);
    if (e.target.checked) {
      currentFilter.push(SegmentFilters.COUNTRY_FILTER);
      dispatch(updateActiveFilters(currentFilter));
    } else {
      setSelectedCountries([]);
      dispatch(updateCountries([]));
      dispatch(updateActiveFilters(currentFilter));
    }
  };

  const onCountryChange = e => {
    dispatch(updateCountries(e));
    setSelectedCountries(e);
  };

  return (
    <>
      <Row gridGap="S100">
        <Checkbox
          data-testid="rule-filter-3"
          checked={!isDisabled}
          onChange={e => onFilterChange(e)}
        />
        <Label display="flex" fontSize={'T300'} htmlFor="rule-filter-3" id="rule-filter-label3">
          <Text style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <FormattedMessage id="app.ruleFilter.label.countryIs" defaultMessage="Country is" />
          </Text>

          <Spacer width="10px" />
          <IconWithTooltip title="Country" tooltipText={COUNTRY_INFO} color="primary70" />
        </Label>
      </Row>
      <Row gridGap="S100">
        <Col width={'10%'}>
          <InputWrapper id="countries-condition">
            {inputProps => (
              <Select disabled={isDisabled} options={['Is']} {...inputProps} value={'Is'} />
            )}
          </InputWrapper>
        </Col>
        <Col width={'50%'}>
          <MultiSelectInput
            elementId="country-options"
            disabled={isDisabled}
            options={countriesOptions}
            values={selectedCountries}
            onChangeHandler={e => {
              onCountryChange(e);
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default CountryFilter;
